import Slick from './Slick'

class QuickView {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.dataset.quickView)
        this._modal = null
        this._modalSlider = null
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            this._launchQuickView()
        })
    }

    _launchQuickView () {
        // Find the corresponding modal
        this._modal = document.querySelector('#' + this._options.productHandle)
        // Show it
        this._modal.classList.add('show')
        // Get the slider within the modal
        this._sliderElement = this._modal.querySelector('[data-slick]')
        // Create a new Slick instance
        this._modalSlider = new Slick(this._theme, this._sliderElement)
        // Reinitialise it
        this._modalSlider._unslick()
        this._modalSlider.onInit()
        this._addCloseListener()
    }

    _addCloseListener () {
        const modalCloseButton = this._modal.querySelector('.popup--close')
        modalCloseButton.addEventListener('click', () => {
            this._modal.classList.remove('show')
        })
    }
}

export default QuickView



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuickView.js